// extracted by mini-css-extract-plugin
module.exports = {"search-list":"NearbyFeaturesList_search-list__P37wG","list-title":"NearbyFeaturesList_list-title___WKG3","list-link":"NearbyFeaturesList_list-link__ZBF64"};